import React from "react";
import boing from "../media/boing.76a65128.jpg";

export default function Obedience() {
  return (
    <>
      <img src={boing} alt="Obedience" className="float-end" />
      <h1>Private Obedience Classes</h1>
      <p>
        Interested in private dog obedience classes &mdash; just for you and
        your pooch, in the comforts of your own home? Read on. We've got just
        the person for you. Meet our Founder!
      </p>
      <p>
        Hello, I'm Rachel, owner and dog trainer at Doggie Doos and Don'ts. I
        have been passionate about working with animals since childhood. At 18,
        I chose to pursue a career that would enable me to help people better
        understand and communicate with dogs. I attended{" "}
        <a
          href="https://www.animalbehaviorcollege.com/"
          rel="noopener"
          aria-label="Facebook"
        >
          Animal Behavioral College
        </a>{" "}
        in 2006, which lead to me becoming a certified dog trainer. I have been
        working with pooches ever since and thoroughly enjoy what I do for a
        living.
      </p>
      <p>
        If you're in need of help with your dog, I am pleased to offer you my
        dog training services through private, in-home obedience classes that
        are tailored specifically to address whatever problems or goals you may
        have in mind. Additionally, we offer &quot;Responsible Pet Owner&quot;
        classes for children!
      </p>
      <p>
        Prices for private obedience classes vary, depending on your needs.
        Please contact us directly for more details.
      </p>
    </>
  );
}
